<template>
  <div class="page-container">
    <ul class="mo-paging">
      <li class="page-index" v-if="!isSimple" @click="first">首页</li>
      <!-- prev -->
      <li
        style="width:60px;"
        :class="[
          'paging-item',
          'paging-item--prev',
          { 'paging-item--disabled': index === 1 }
        ]"
        @click="prev"
      >
        <!-- <i class="el-icon-arrow-left"></i> -->
        <!-- <a-icon type="left" /> -->
        <span>上一页</span>
      </li>

      <!-- first -->
      <!-- <li
        :class="['paging-item', 'paging-item--first', {'paging-item--disabled' : index === 1}]"
        @click="first">first</li> -->

      <li :class="['paging-item', 'paging-item--more']" v-show="showPrevMore">
        ...
      </li>

      <li
        :class="['paging-item', { 'paging-item--current': index === pager }]"
        v-for="pager in pagers"
        @click="go(pager)"
      >
        {{ pager }}
      </li>

      <li :class="['paging-item', 'paging-item--more']" v-show="showNextMore">
        ...
      </li>

      <!-- next -->
      <li
        :class="[
          'paging-item',
          'paging-item--next',
          { 'paging-item--disabled': index === pages }
        ]"
        @click="next"
      >
        下一页
        <!-- <a-icon type="right" /> -->
        <!-- <i class="el-icon-arrow-right"></i> -->
      </li>
      <!-- last -->
      <li
        v-if="!isSimple"
        :class="[
          'paging-item',
          'paging-item--last',
          { 'paging-item--disabled': index === pages }
        ]"
        @click="last"
      >
        尾页
      </li>
    </ul>
    <div class="total-page">
      <span v-if="!isSimple">共{{ total }}条</span><span>共{{ pages }}页</span>
    </div>
    <!-- <div class="total-page">{{ index }}/{{ pages }}</div> -->
    <div class="jumper" v-if="!isSimple">
      到第
      <el-input style="width:inherit" v-model="inputPage" @change="inputFunc" />
      <!-- <input type="text" v-model="inputPage" v-on:input="inputFunc" step="1" :max="pages" :min="1" /> -->
      页
      <button class="go-to" @click="confirm">
        <span>前往</span
        ><img
          class="default"
          src="../../../../assets/img/common/icon-arrow-right.png"
          alt=""
        />
        <img class="hover" src="../../../../assets/img/common/icon-go-to.png" alt="" />
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "MoPaging",
  //通过props来接受从父组件传递过来的值
  props: {
    //页面中的可见页码，其他的以...替代, 必须是奇数
    perPages: {
      type: Number,
      default: 5
    },

    //当前页码
    pageIndex: {
      type: Number,
      default: 1
    },

    //每页显示条数
    pageSize: {
      type: Number,
      default: 10
    },

    //总记录数
    total: {
      type: Number,
      default: 1
    },
    //是否是精简版分页
    isSimple: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    prev() {
      if (this.index > 1) {
        this.go(this.index - 1);
      }
    },
    next() {
      if (this.index < this.pages) {
        this.go(this.index + 1);
      }
    },
    first() {
      if (this.index !== 1) {
        this.go(1);
      }
    },
    last() {
      if (this.index != this.pages) {
        this.go(this.pages);
      }
    },
    go(page) {
      if (this.index !== page) {
        this.index = page;
        //父组件通过change方法来接受当前的页码
        this.$emit("change", this.index);
      }
    },
    inputFunc(e) {
      // let num = e.data.trim();
      //   console.log(num);
      // if (num == null || num == "") {
      //   return;
      // }
      // if (e.data >= this.pages) {
      //   this.index = parseInt(this.pages);
      //   this.inputPage = parseInt(this.pages);
      // } else {
      //   if (parseInt(e.data) === 0) {
      //     this.index = 1;
      //     this.inputPage = 1;
      //   } else {
      //     this.index = parseInt(e.data);
      //     this.inputPage = parseInt(e.data);
      //   }
      // }
      // this.$emit("change", this.index);
    },
    confirm() {
      if (!this.inputPage) return;
      this.inputPage = this.inputPage.trim();
      if (this.inputPage <= 0) {
        this.inputPage = 1;
      }
      if (this.inputPage == null || this.inputPage == "") {
        return;
      }
      if (this.inputPage >= this.pages) {
        this.index = parseInt(this.pages);
        this.inputPage = parseInt(this.pages);
      } else {
        if (parseInt(this.inputPage) === 0) {
          this.index = 1;
          this.inputPage = 1;
        } else {
          this.index = parseInt(this.inputPage);
        }
      }
      //  this.index = parseInt(this.inputPage );
      // this.inputPage = parseInt(e.data);
      this.$emit("change", this.index);
    }
  },
  computed: {
    //计算总页码
    pages() {
      // console.log(Math.ceil(this.size / this.limit));
      return Math.ceil(this.size / this.limit);
    },

    //计算页码，当count等变化时自动计算
    pagers() {
      const array = [];
      const perPages = this.perPages;
      const pageCount = this.pages;
      let current = this.index;
      const _offset = (perPages - 1) / 2;

      const offset = {
        start: current - _offset,
        end: current + _offset
      };

      //-1, 3
      if (offset.start < 1) {
        offset.end = offset.end + (1 - offset.start);
        offset.start = 1;
      }
      if (offset.end > pageCount) {
        offset.start = offset.start - (offset.end - pageCount);
        offset.end = pageCount;
      }
      if (offset.start < 1) offset.start = 1;

      this.showPrevMore = offset.start > 1;
      this.showNextMore = offset.end < pageCount;

      for (let i = offset.start; i <= offset.end; i++) {
        array.push(i);
      }

      return array;
    }
  },
  data() {
    return {
      index: this.pageIndex, //当前页码
      limit: this.pageSize, //每页显示条数
      size: this.total || 1, //总记录数
      showPrevMore: false,
      showNextMore: false,
      inputPage: null
    };
  },
  watch: {
    pageIndex(val) {
      this.index = val || 1;
    },
    pageSize(val) {
      this.limit = val || 10;
    },
    total(val) {
      this.size = val || 1;
    }
  }
};
</script>
<style lang="scss" scoped>
// @import "../assets/style/common.scss";
.page-container {
  font-size: 0;
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .mo-paging {
    display: inline-block;
    padding: 0;
    // margin: 1rem 0;
    font-size: 0;
    list-style: none;
    user-select: none;
    .page-index {
      width: 60px;
      height: 30px;
      line-height: 28px;
      font-size: 14px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #999999;
      text-align: center;
      display: inline-block;
      border: 1px solid #d9d9d9;
      // border-radius: 3px;
      &:hover {
        color: #2587FF;
        border: 1px solid #2587FF;
      }
    }
    > .paging-item {
      display: inline-block;
      font-size: 14px;
      position: relative;
      // padding: 6px 12px;
      //   line-height: 1.42857143;
      text-decoration: none;
      border: 1px solid #d9d9d9;
      background-color: #fff;
      margin-left: -1px;
      cursor: pointer;
      color: #666666;
      width: 40px;
      height: 30px;
      line-height: 28px;
      text-align: center;
      // background: #f0f2f5;
      // border-radius: 3px;
      //   border: 1px solid #d7dbe0;
      margin-left: 10px;
      &:first-child {
        margin-left: 0;
      }
      &:hover {
        color: #2587FF;
        border: 1px solid #2587FF;
      }
      &.paging-item--disabled,
      &.paging-item--more {
        background-color: #fff;
        color: #505050;
      }
      //禁用
      &.paging-item--disabled {
        cursor: not-allowed;
        opacity: 0.75;
      }
      &.paging-item--more,
      &.paging-item--current {
        cursor: default;
      }
      //选中
      &.paging-item--current {
        background: #2587FF;
        // border-radius: 3px;
        //   background-color: #0275d8;
        color: #fff;
        position: relative;
        z-index: 1;
        border-color: #2587FF;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        // top:-2px;
        //   color: #ffffff;
      }
      &.paging-item--next {
        width: 60px;
      }
    }
    .paging-item.paging-item--last {
      color: #999999;
    }
  }
  .total-page {
    margin-left: 12px;
    display: inline-block;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    span {
      font-size: 14px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #999999;
    }
    span:nth-child(1) {
      margin-right: 20px;
    }
  }
  .jumper {
    margin-left: 6px;
    display: inline-block;
    font-size: 14px;
    // font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    input {
      width: 63px;
      height: 26px;
      background: #ffffff;
      // border-radius: 3px;
      border: 1px solid #e6e6e6;
      margin: 0 4px;
      text-align: center;
    }
    .go-to {
      width: 60px;
      height: 30px;
      background: #fff;
      // border-radius: 3px;
      border: 1px solid #d7dbe0;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999;
      cursor: pointer;
      display: inline-block;
      line-height: 28px;
      padding: 0 10px;
      .default {
        display: inline-block;
      }
      .hover {
        display: none;
      }
      &:hover {
        border: 1px solid #2587FF;
        color: #2587FF;
        .hover {
          display: inline-block;
        }
        .default {
          display: none;
        }
      }
      img {
        float: right;
        width: 8px;
        margin-top: 9px;
        /* margin-right: 1px; */
        height: 10px;
      }
    }
  }
  ::v-deep .el-input__inner {
    width: 40px;
    height: 30px;
    line-height: 28px;
    border-radius: 0;
    padding: 0;
    text-align: center;
    &:hover {
      border: 1px solid #2587FF;
    }
  }
}
</style>
